import { writable } from 'svelte/store';
export const videoScale = writable({
    videoHeight: 0,
    videoWidth: 0,
    scale: 0
});
